import Footer from "./Footer";
import NavBar from "./NavBar";
import CardTiposDePagamentos from "./CardTiposDePagamentos";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function TiposDePagamentos() {

    const navigate = useNavigate();

    const propsCardPlanoResidencial = {
        url: "../../images/vodacom.png",
        descricao: "Pagamento via M-pesa"
    }

    const propsCardPlanoEmpresarial = {
        url: "../../images/movitel.jpeg",
        descricao: "Pagamento via E-mola"
    }

    return (
        <div className="flex h-screen flex-col font-questrial text-white">
        {/* NavBar */}
        <div className="bg-blue-500 lg:h-[240px] h-[20%] sticky top-0 z-10">
          <NavBar />
        </div>
        {/* Botões de pagamento */}
        <button className="group absolute left-4 bottom-[76%]" onClick={() => {
          navigate(-1)
        }}>
          <div className="flex md:flex lg:hidden">
            <div>
              <ChevronLeft className="group-hover:font-semibold text-black" />
            </div>
            <div>
              <span className="text-sm group-hover:font-semibold text-black">Voltar</span>
            </div>
          </div>
        </button>
        <div className="flex-grow lg:z-20 mt-8 lg:-mt-[180px] gap-2 sm:flex items-center justify-center sm:flex-col sm:justify-center md:flex-row md:justify-between lg:w-[600px] mx-auto p-4">
        
          <div className="w-full sm:w-[41%]  md:w-[48%] mb-4 sm:mb-4 md:mb-0">
            <button onClick={() => navigate("/pagamentoviampesa")}>
              <CardTiposDePagamentos {...propsCardPlanoResidencial} />
            </button>
          </div>
          <div className="w-full sm:w-[41%] md:w-[48%]">
            <button onClick={() => {
              alert("Tipo de Pagamento Nao Disponivel")
            }}>
              <CardTiposDePagamentos {...propsCardPlanoEmpresarial} />
            </button>
          </div>
        </div>
      
        {/* Footer */}
        <div className="bg-blue-500 p-4 pb-2">
          <Footer />
        </div>
      </div>
      
    )
}